import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Button, Spinner } from 'react-bootstrap';

export const ApproveButton = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [messageText, setMessageText] = useState('');

  useEffect(() => {
    setMessageText('');
    return () => {};
  }, []);

  async function onClickApproveButton(e) {
    if (props.action === 'approve') {
      props.updateBaseProductAttribute(e, 0); //updates state
      props.setCachedSelectedRows(props.selectedRows);
      await updateProduct(0); //updates db
    } else {
      Object.values(props.selectedRows).forEach(async (product, index) => {
        props.updateBaseProductAttribute(e, index); //updates state
        props.setCachedSelectedRows(props.selectedRows);
        await updateProduct(index); //updates db
      });
    }
  }

  function updateProduct(index) {
    setIsLoading(true);
    setMessageText('');
    console.log('isloading');

    axios
      .post(process.env.REACT_APP_HOST + 'updateProduct', {
        params: {
          product: props.selectedRows[index],
        },
      })
      .then((res) => {
        setTimeout(() => {
          setIsLoading(false);
          setMessageText('Saved!')
        }, 400);
      })
      .catch((err) => {});
  }

  return (
    <div>
      <Button
        name='approved'
        variant='success'
        size='lg'
        onClick={(e) => {
          onClickApproveButton(e);
        }}
        value={true}
      >
        {isLoading && <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' />}
        {props.action === 'approve' ? 'Approve': 'Save'}
      </Button>
      <div>{messageText}</div>
    </div>
  );
};
